import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider } from "@mui/material";
import { clearFilters } from "components/common/Filters/Filters.slice";
import KebabMenu from "components/common/KebabMenu";
import Typography from "components/common/Typography";
import { uniqueId } from "lodash";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { checkWithLowerCase } from "utils/CommonChecker";
import { resetSorting, setCorpViewSelectedTab, setSelectedList, setSelectedListCategory } from "../CorpUser.Slice";

interface Props {
  item: any;
  setOpen: (val: boolean) => void;
  searchedText: string;
  keyId: string;
}
const AccordionData = (props: Props) => {
  const { item, setOpen, searchedText, keyId } = props;
  const listCategory = useAppSelector((state) => state.CorpDashboard.myListsSelected.listCategory);
  const selectedList = useAppSelector((state) => state.CorpDashboard.myListsSelected.selectedList);
  const dispatch = useAppDispatch();

  const excludedPinAndUnPin = (item: any, isFlagged: string) => {
    return item?.listType !== "bookmarked"
      ? item?.menu?.filter((m: any) =>
          checkWithLowerCase(isFlagged ?? "", "Y") ? m.label !== "Pin to top" : m.label !== "Unpin from top"
        )
      : item?.menu;
  };

  return (
    <Accordion
      className="my-list-corp-accordian-main"
      defaultExpanded={searchedText?.length > 2 || listCategory === item.listType}
      key={uniqueId(keyId)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="my-list-corp-accordian-summary">
        <Typography variant="body2">{item.label}</Typography>
      </AccordionSummary>
      <AccordionDetails className="my-list-corp-accordian-detail">
        <Divider></Divider>
        {item?.data?.map((el: any, index: number) => {
          return (
            <Box
              key={uniqueId(el.id)}
              className={`my-list-corp-data ${
                item?.listType === listCategory && el?.name === selectedList?.name ? "selected-list" : ""
              }`}
              onClick={() => {
                dispatch(setSelectedList(el));
                dispatch(clearFilters({ skipView: true, eliminateMyList: true }));
                dispatch(setSelectedListCategory(item.listType));
                dispatch(
                  resetSorting({
                    type: "myList"
                  })
                );

                if (item.listType === "bookmarked") dispatch(setCorpViewSelectedTab({ type: "myList", val: index }));
                else dispatch(setCorpViewSelectedTab({ type: "myList", val: 0 }));
                setOpen(false);
              }}
            >
              <Typography variant="body2" showBold className="ellipse-two ">
                {el?.name || ""}
              </Typography>
              <div className={item?.listType !== "bookmarked" ? "list-pin-menu" : "d-none"}>
                <Box className={checkWithLowerCase(el?.isFlagged ?? "", "Y") ? "list-pinned" : "list-unpinned"}></Box>
              </div>
              <KebabMenu options={excludedPinAndUnPin(item, el?.isFlagged)} value={el} />
            </Box>
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
};
export default AccordionData;
